import { useEffect, useState } from 'react';
import { useSubmitDemoLead } from '../api/mutations';
import {
  LAST_STEP,
  STEPS,
  choose,
  draftSnapshot,
  restoreDraft,
  submitErrorMessage,
  submittedSummary,
  validateStep,
} from '../model/demoLead';

const DRAFT_KEY = 'fleetManagerLeadDraft';

const readDraft = () => {
  try {
    return restoreDraft(window.localStorage.getItem(DRAFT_KEY));
  } catch {
    return restoreDraft(null);
  }
};

// Senza storage (navigazione privata, quota piena) la bozza non si salva, il modulo funziona.
const writeDraft = (write) => {
  try {
    write(window.localStorage);
  } catch {
    // La bozza è una comodità: perderla non blocca la compilazione.
  }
};

/** Il questionario demo: step, errori, bozza nel browser e invio. */
export function useDemoRequestScreen() {
  const submit = useSubmitDemoLead();
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [lead, setLead] = useState(readDraft);

  useEffect(() => {
    if (submit.isSuccess) return;
    writeDraft((storage) => storage.setItem(DRAFT_KEY, JSON.stringify(lead)));
  }, [lead, submit.isSuccess]);

  const checkStep = () => {
    const stepErrors = validateStep(step, lead);
    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  if (submit.isSuccess) {
    return { submitted: true, summary: submittedSummary(submit.variables) };
  }

  return {
    submitted: false,
    step,
    steps: STEPS,
    isLastStep: step === LAST_STEP,
    lead,
    errors,
    snapshot: draftSnapshot(lead),
    submitting: submit.isPending,
    submitError: submit.isError ? submitErrorMessage(submit.error) : null,
    onText: (field, value) => setLead((current) => ({ ...current, [field]: value })),
    onChoose: (field, value) => setLead((current) => choose(current, field, value)),
    onBack: () => setStep((current) => Math.max(current - 1, 0)),
    onNext: () => {
      if (checkStep()) setStep((current) => Math.min(current + 1, LAST_STEP));
    },
    onSubmit: (event) => {
      event.preventDefault();
      if (!checkStep()) return;
      submit.mutate(lead, {
        onSuccess: () => writeDraft((storage) => storage.removeItem(DRAFT_KEY)),
      });
    },
  };
}
